export const UPDATE_SETTINGS = {
  TITLE: 'Update Fintel Check Settings',
  DESCRIPTION: 'New settings will be applied on the next period, starting',
  CANCEL: 'Cancel',
  SAVE: 'Update Settings',
};
